import React, { forwardRef } from 'react';
import propTypes from 'prop-types';

const Input = forwardRef(({ type, value, handleChange, handleKeyPress, index }, ref) => (
  <input
    type={type}
    value={value}
    ref={ref}
    onChange={e => handleChange(e.target.value, index)}
    onKeyUp={e => handleKeyPress(e.keyCode, index)}
    maxLength={1}
    className="form-control"
  />
));

Input.propTypes = {
  type: propTypes.oneOfType([propTypes.object, propTypes.string]).isRequired,
  value: propTypes.oneOfType([propTypes.object, propTypes.string]),
  handleChange: propTypes.func.isRequired,
  handleKeyPress: propTypes.func.isRequired,
}

export default Input;